var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "chat-wrapper" }, [
    _c("div", { staticClass: "chat-sidebar" }, [
      _c("div", { staticClass: "chat-sidebar-body" }, [
        _c("div", { staticClass: "flex-fill pd-y-20 pd-x-10" }, [
          _c(
            "p",
            {
              staticClass:
                "tx-10 tx-uppercase tx-medium tx-color-03 tx-sans tx-spacing-1 pd-l-10 mg-b-10"
            },
            [_vm._v("Members List")]
          ),
          _vm._v(" "),
          _c(
            "div",
            { staticClass: "chat-member-list" },
            _vm._l(_vm.memberList, function(form, i) {
              return _c("div", { staticClass: "media" }, [
                form.id == _vm.userid
                  ? _c(
                      "div",
                      { staticClass: "avatar avatar-sm avatar-online" },
                      [
                        _c(
                          "span",
                          { staticClass: "avatar-initial rounded-circle" },
                          [_vm._v(_vm._s(form.name.substr(0, 1)))]
                        )
                      ]
                    )
                  : _c("div", { staticClass: "avatar avatar-sm" }, [
                      _c(
                        "span",
                        { staticClass: "avatar-initial rounded-circle" },
                        [_vm._v(_vm._s(form.name.substr(0, 1)))]
                      )
                    ]),
                _vm._v(" "),
                _c("div", { staticClass: "media-body mg-l-10" }, [
                  _c("h6", { staticClass: "mg-b-0" }, [
                    _vm._v(_vm._s(form.name))
                  ])
                ])
              ])
            }),
            0
          )
        ])
      ])
    ]),
    _vm._v(" "),
    _c("div", { staticClass: "chat-content mg-l-1-f" }, [
      _c("div", { staticClass: "chat-content-header" }, [
        _c("h6", { staticClass: "mg-b-0", attrs: { id: "channelTitle" } }, [
          _vm._v("#" + _vm._s(_vm.chatRoomName))
        ])
      ]),
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "chat-content-body" },
        [
          _c(
            "vueCustomScrollbar",
            { staticClass: "chatting-height", attrs: { id: "chat" } },
            [
              _c(
                "div",
                { ref: "chatInfo", staticClass: "chat-group" },
                _vm._l(_vm.readData, function(form, i) {
                  return _c("div", [
                    form.createDate.length > 0
                      ? _c(
                          "div",
                          { staticClass: "chat-group-divider mt-3 mb-3" },
                          [_vm._v(_vm._s(form.createDate))]
                        )
                      : _vm._e(),
                    _vm._v(" "),
                    form.userId != _vm.userid
                      ? _c("div", { staticClass: "media" }, [
                          form.userName.length > 0
                            ? _c("div", { staticClass: "avatar avatar-sm" }, [
                                _c(
                                  "span",
                                  {
                                    staticClass: "avatar-initial rounded-circle"
                                  },
                                  [_vm._v(_vm._s(form.userName.substr(0, 1)))]
                                )
                              ])
                            : _c("div", { staticClass: "avatar avatar-sm" }),
                          _vm._v(" "),
                          _c("div", { staticClass: "media-body" }, [
                            _c("h6", [_vm._v(_vm._s(form.userName))]),
                            _vm._v(" "),
                            _c("p", [
                              _vm._v(_vm._s(form.message)),
                              form.createTime.length > 0
                                ? _c("small", { staticClass: "ml-2" }, [
                                    _vm._v(_vm._s(form.createTime))
                                  ])
                                : _vm._e()
                            ])
                          ])
                        ])
                      : _c("div", { staticClass: "media" }, [
                          _c(
                            "div",
                            { staticClass: "media-body tx-right-f mr-4" },
                            [
                              _c("h6", [_vm._v(_vm._s(form.userName))]),
                              _vm._v(" "),
                              _c("p", [
                                form.createTime.length > 0
                                  ? _c("small", { staticClass: "mr-2" }, [
                                      _vm._v(_vm._s(form.createTime))
                                    ])
                                  : _vm._e(),
                                _vm._v(_vm._s(form.message) + " ")
                              ])
                            ]
                          ),
                          _vm._v(" "),
                          form.userName.length > 0
                            ? _c(
                                "div",
                                {
                                  staticClass: "avatar avatar-sm avatar-online"
                                },
                                [
                                  _c(
                                    "span",
                                    {
                                      staticClass:
                                        "avatar-initial rounded-circle"
                                    },
                                    [_vm._v(_vm._s(form.userName.substr(0, 1)))]
                                  )
                                ]
                              )
                            : _c("div", { staticClass: "avatar avatar-sm" })
                        ])
                  ])
                }),
                0
              )
            ]
          )
        ],
        1
      ),
      _vm._v(" "),
      _c("div", { staticClass: "chat-content-footer" }, [
        _c("input", {
          directives: [
            {
              name: "model",
              rawName: "v-model",
              value: _vm.message,
              expression: "message"
            }
          ],
          staticClass: "form-control align-self-center bd-0",
          attrs: { type: "text", placeholder: "Message" },
          domProps: { value: _vm.message },
          on: {
            keyup: function($event) {
              if (
                !$event.type.indexOf("key") &&
                _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")
              ) {
                return null
              }
              return _vm.sendMessage($event)
            },
            input: function($event) {
              if ($event.target.composing) {
                return
              }
              _vm.message = $event.target.value
            }
          }
        }),
        _vm._v(" "),
        _c(
          "nav",
          { staticClass: "svg-cursor" },
          [
            _c("feather", {
              staticClass: "wd-25 hd-25 valign-middle-f svg_overflow",
              attrs: { type: "send" },
              on: { click: _vm.sendMessage }
            })
          ],
          1
        )
      ])
    ])
  ])
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-aa145a5c", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-aa145a5c","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/views/Common/Chat.vue
// module id = null
// module chunks = 